import { A11yModule } from '@angular/cdk/a11y';
import { CdkNoDataRow } from '@angular/cdk/table';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KwaAngular18Module } from '@komodo-design-system/komodo-kwa-angular-18';
import { SharedModule } from 'app/shared.module';

import { KpiChartsExpandedPanelComponent } from './kpi-charts-expanded-panel/kpi-charts-expanded-panel.component';
import { KpiChartsPanelHeader } from './kpi-charts-panel-header/kpi-charts-panel-header.component';
import { KpiChartsSidePanelComponent } from './kpi-charts-side-panel.component';

@NgModule({
  declarations: [
    KpiChartsSidePanelComponent,
    KpiChartsExpandedPanelComponent,
    KpiChartsPanelHeader
  ],
  exports: [KpiChartsSidePanelComponent],
  imports: [BrowserModule, KwaAngular18Module, SharedModule, A11yModule, CdkNoDataRow],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KpiChartsSidePanelModule {}
